import { cx } from '@emotion/css';
import type { FC } from 'react';

import { getBackgroundClassName } from '../../../utils';
import {
  footerBarContainerCss,
  footerBarContainerOffsetCss,
  footerBarCss,
  wrapperCss,
} from './styles';
import type { FooterBarProps } from './types';

export const FooterBar: FC<FooterBarProps> = ({ children, backgroundColor, hasSideNav }) => {
  return (
    <div
      data-testid="footer-bar"
      className={cx(getBackgroundClassName(backgroundColor), wrapperCss)}
    >
      <div className={cx(footerBarContainerCss, { [footerBarContainerOffsetCss]: hasSideNav })}>
        <div className={footerBarCss}>{children}</div>
      </div>
    </div>
  );
};
